import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaHome, FaBriefcase, FaTools, FaProjectDiagram, FaFileAlt, FaAddressBook, FaCode } from 'react-icons/fa';
import './Navbar.css';
import netflixLogo from '../images/logo-2.png';
import blueImage from '../images/blue.png';

const Navbar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const profileImage = location.state?.profileImage || blueImage;

  const handleScroll = () => {
    setIsScrolled(window.scrollY > 80);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleSidebar();
    }
  };

  return (
    <>
      <nav
        className={`navbar ${isScrolled ? 'scrolled' : ''}`}
        role="navigation"
        aria-label="Main navigation"
      >
        <div className="navbar-left">
          <Link to="/" className="navbar-logo" aria-label="Shivom Sharma Portfolio - Home">
            <img
              src={netflixLogo}
              alt="Shivom Sharma Portfolio Logo"
              width="120"
              height="40"
            />
          </Link>
          <ul className="navbar-links" role="menubar">
            <li role="none"><Link to="/browse" role="menuitem">Home</Link></li>
            <li role="none"><Link to="/work-experience" role="menuitem">Professional</Link></li>
            <li role="none"><Link to="/skills" role="menuitem">Skills</Link></li>
            <li role="none"><Link to="/projects" role="menuitem">Projects</Link></li>
            <li role="none"><Link to="/open-source" role="menuitem">Open Source</Link></li>
            <li role="none"><Link to="/resume" role="menuitem">Resume</Link></li>
            <li role="none"><Link to="/contact" role="menuitem">Contact</Link></li>
          </ul>
        </div>
        <div className="navbar-right">
          {/* Hamburger menu for mobile */}
          <button
            className="hamburger"
            onClick={toggleSidebar}
            onKeyDown={handleKeyDown}
            aria-label={isSidebarOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={isSidebarOpen}
            aria-controls="mobile-sidebar"
            type="button"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </button>
          <button
            className="profile-icon-button"
            onClick={() => { navigate('/browse') }}
            aria-label="Switch profile - go to profile selection"
            type="button"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <img
              src={profileImage}
              alt="Current user profile avatar"
              className="profile-icon"
              width="32"
              height="32"
            />
          </button>
        </div>
      </nav>

      {/* Sidebar Overlay */}
      <div
        className={`sidebar-overlay ${isSidebarOpen ? 'open' : ''}`}
        onClick={closeSidebar}
        aria-hidden="true"
      ></div>

      {/* Sidebar (only visible on mobile) */}
      <aside
        id="mobile-sidebar"
        className={`sidebar ${isSidebarOpen ? 'open' : ''}`}
        role="dialog"
        aria-label="Mobile navigation menu"
        aria-hidden={!isSidebarOpen}
      >
        <div className="sidebar-logo">
          <img
            src={netflixLogo}
            alt="Shivom Sharma Portfolio Logo"
            width="120"
            height="40"
          />
        </div>
        <nav aria-label="Mobile navigation">
          <ul role="menu">
            <li role="none">
              <Link to="/browse" onClick={closeSidebar} role="menuitem">
                <FaHome aria-hidden="true" /> Home
              </Link>
            </li>
            <li role="none">
              <Link to="/work-experience" onClick={closeSidebar} role="menuitem">
                <FaBriefcase aria-hidden="true" /> Professional
              </Link>
            </li>
            <li role="none">
              <Link to="/skills" onClick={closeSidebar} role="menuitem">
                <FaTools aria-hidden="true" /> Skills
              </Link>
            </li>
            <li role="none">
              <Link to="/projects" onClick={closeSidebar} role="menuitem">
                <FaProjectDiagram aria-hidden="true" /> Projects
              </Link>
            </li>
            <li role="none">
              <Link to="/resume" onClick={closeSidebar} role="menuitem">
                <FaFileAlt aria-hidden="true" /> Resume
              </Link>
            </li>
            <li role="none">
              <Link to="/open-source" onClick={closeSidebar} role="menuitem">
                <FaCode aria-hidden="true" /> Open Source
              </Link>
            </li>
            <li role="none">
              <Link to="/contact" onClick={closeSidebar} role="menuitem">
                <FaAddressBook aria-hidden="true" /> Contact
              </Link>
            </li>
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Navbar;
